import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-cream border-y border-gold-aged/30" data-id="element-141" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-142" data-mp="223oejhmj3wdd">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-forest border border-gold rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-143" data-mp="222n156i1ixsh">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold" data-id="element-144" data-mp="14gz4ckhoadgf" />

          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-ivory/10 border border-gold/50 text-gold mb-8" data-id="element-145" data-mp="1j5lu7g4xenlw">
            <ShieldCheck size={48} data-id="element-146" data-mp="1ebr49uyq9ced" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-ivory" data-id="element-147" data-mp="qnhp3bw0rmw7">
            🛡️ Full 7-Day Money-Back Guarantee
          </h2>

          <div className="space-y-6 text-lg text-ivory/80 max-w-2xl mx-auto" data-id="element-148" data-mp="ln27g84pft8f">
            <p data-id="element-149" data-mp="oz02jss8lwn9">
              Open the complete 6-in-1 system. Explore all 5 bonuses. Use the
              material in your most challenging lesson this week.
            </p>
            <p className="font-medium text-ivory" data-id="element-150" data-mp="yqdzptwpukd8">
              If you feel the material is not clear, practical, or useful for
              your teaching needs, contact us within 7 days.
            </p>
            <p className="text-gold font-bold text-xl" data-id="element-151" data-mp="61yx66urtuis">
              We will refund 100% of your money. No questions. No forms. No
              complications.
            </p>
            <p className="text-sm text-ivory/60 mt-8" data-id="element-152" data-mp="f12htf9l6hze">
              Because if the material doesn't deliver the value we promise, we
              don't want your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}